// Meta Pixel Event Tracking Helper
// Documentation: https://developers.facebook.com/docs/meta-pixel/reference

/**
 * Track a Meta Pixel event
 * @param {string} eventName - Standard or custom event name
 * @param {object} params - Event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
    console.log(`[Meta Pixel] Tracked: ${eventName}`, params);
  }
};

/**
 * Track Contact event - When user clicks on contact options
 * @param {string} method - Contact method (phone, sms, messenger, instagram)
 */
export const trackContact = (method) => {
  trackEvent('Contact', {
    content_name: 'Contact Click',
    content_category: method,
  });
};

/**
 * Track Lead event - When phone number is revealed
 */
export const trackLead = () => {
  trackEvent('Lead', {
    content_name: 'Phone Number Revealed',
    content_category: 'Phone Reveal',
  });
};

/**
 * Track ViewContent event - When viewing specific content
 * @param {string} contentName - Name of the content viewed
 * @param {string} contentCategory - Category of content
 */
export const trackViewContent = (contentName, contentCategory) => {
  trackEvent('ViewContent', {
    content_name: contentName,
    content_category: contentCategory,
  });
};

/**
 * Track Schedule/Booking intent
 */
export const trackSchedule = () => {
  trackEvent('Schedule', {
    content_name: 'Booking Intent',
  });
};

export default {
  trackEvent,
  trackContact,
  trackLead,
  trackViewContent,
  trackSchedule,
};
